import React, { useCallback, useEffect } from 'react';
import { IKlarityProgramPackage } from 'types/programs';
import { getKlarityProgramPackageDetail } from 'api/operation/programs';

const useGetPackageDetail = (id: number):[IKlarityProgramPackage|undefined, boolean, (id: number)=>void] => {
    const [loading, setLoading] = React.useState(false);
    const [item, setItem] = React.useState<IKlarityProgramPackage>();
    const fetchData = useCallback(async (id: number) => {
        if (loading || !id) return;
        try {
            setLoading(true);
            const result = await getKlarityProgramPackageDetail(id);
            if (!result.error) {
                const resData = result?.data?.data || [];

                setItem(resData);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, [loading]);

    useEffect(() => {
        fetchData(id);
    }, [id]);

    return [item, loading, fetchData];
};

export default useGetPackageDetail;
